<div class="modal-outer-wrapper mt-4 common-confirm">
    <div class="modal-inner-wraper delete-popup">
        <img *ngIf="successIcon" src="assets/images/confirm-icon.png" alt="Confirm"/>            
        <img *ngIf="errorIcon" src="assets/images/delete-icon-popup.svg" alt="Delete"/>            
        <h2 [ngClass]="{ 'error-text': errorIcon }">{{headerText}}</h2>
        <p [innerHtml]="bodyText"></p>
        <div class="flex justify-content-center gap-2 mb-4 ">
            <p-button label="Yes" class="btn-continue" (onClick)="onConfirm()"></p-button>
            <p-button label="No" class="btn-delete" styleClass="p-button-outlined" (onClick)="onCancel()"></p-button>
        </div>
    </div>
</div>

  